import { useRouter } from 'next/router';
import { Text, Flex, Stack, Dot, Box as CommonBox } from '@pairy/pds-react';

import { BulkTrackClient } from '@/hooks/queries/file/useFileBulkClientTrackList';
import { getUTCDate } from '@/utils/getUTCDate';

import * as Styled from './index.styles';

interface Props extends BulkTrackClient {}

const Box = ({ name, readCount, lastAction, isChecked }: Props) => {
  const router = useRouter();

  const handleClickBox = () => {
    router.push(`/user/pdf/activity-analysis?fileId=${router.query.fileId}`);
  };

  return (
    <CommonBox as="button" onClick={handleClickBox}>
      <Stack gap={8}>
        <div>
          <Dot
            color={isChecked ? 'transparent' : 'vermillion_400'}
            marginTop={5}
            marginRight={5}
            marginBottom={5}
            marginLeft={5}
          />
        </div>
        <Stack direction="column" gap={8}>
          <Stack alignItems="center" gap={4}>
            <Text as="p" variant="md-bold">
              {name ?? '익명'}
            </Text>
          </Stack>
          <Flex>
            <Styled.Divider>
              {readCount && (
                <>
                  <Text variant="sm-semibold" marginRight={8}>
                    열람 횟수
                  </Text>
                  <Text variant="sm-semibold">{readCount}회</Text>
                </>
              )}
            </Styled.Divider>
            <div>
              <Text variant="sm-semibold" marginRight={8} color="zinc_400">
                최근 열람
              </Text>
              <Text variant="sm-regular" color="zinc_400">
                {lastAction ? getUTCDate(lastAction, 'withYear') : '없음'}
              </Text>
            </div>
          </Flex>
        </Stack>
      </Stack>
    </CommonBox>
  );
};

export default Box;
